/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Audio_Embed_TitleInputs */

const en_file_export_audio_embed_title = /** @type {(inputs: File_Export_Audio_Embed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embed Audio`)
};

const fr_file_export_audio_embed_title = /** @type {(inputs: File_Export_Audio_Embed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intégrer l'audio`)
};

const de_file_export_audio_embed_title = /** @type {(inputs: File_Export_Audio_Embed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio einbetten`)
};

const it_file_export_audio_embed_title = /** @type {(inputs: File_Export_Audio_Embed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorpora l'audio`)
};

const ru_file_export_audio_embed_title = /** @type {(inputs: File_Export_Audio_Embed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Встроить аудио`)
};

const es_file_export_audio_embed_title = /** @type {(inputs: File_Export_Audio_Embed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar audio`)
};

const zh_cn2_file_export_audio_embed_title = /** @type {(inputs: File_Export_Audio_Embed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`嵌入音频`)
};

const ja_file_export_audio_embed_title = /** @type {(inputs: File_Export_Audio_Embed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音声を埋め込む`)
};

const hi_file_export_audio_embed_title = /** @type {(inputs: File_Export_Audio_Embed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो एम्बेड करें`)
};

const pt_pt2_file_export_audio_embed_title = /** @type {(inputs: File_Export_Audio_Embed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorporar áudio`)
};

/**
* | output |
* | --- |
* | "Embed Audio" |
*
* @param {File_Export_Audio_Embed_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_audio_embed_title = /** @type {((inputs?: File_Export_Audio_Embed_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Audio_Embed_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_export_audio_embed_title(inputs)
	if (locale === "de") return de_file_export_audio_embed_title(inputs)
	if (locale === "it") return it_file_export_audio_embed_title(inputs)
	if (locale === "ru") return ru_file_export_audio_embed_title(inputs)
	if (locale === "es") return es_file_export_audio_embed_title(inputs)
	if (locale === "zh-CN") return zh_cn2_file_export_audio_embed_title(inputs)
	if (locale === "ja") return ja_file_export_audio_embed_title(inputs)
	if (locale === "hi") return hi_file_export_audio_embed_title(inputs)
	if (locale === "pt-PT") return pt_pt2_file_export_audio_embed_title(inputs)
	return en_file_export_audio_embed_title(inputs)
});